import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  LayoutDashboard, 
  Package, 
  ShoppingCart, 
  Users, 
  Layers, 
  Settings,
  LogOut,
  MessageSquare,
  Mail
} from "lucide-react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

const menuItems = [
  { name: "Dashboard", path: "/admin", icon: <LayoutDashboard size={20} /> },
  { name: "Posts", path: "/admin/posts", icon: <Package size={20} /> },
  { name: "Messages", path: "/admin/messages", icon: <MessageSquare size={20} /> },
  { name: "Orders", path: "/admin/orders", icon: <ShoppingCart size={20} /> },
  { name: "Users", path: "/admin/users", icon: <Users size={20} /> },
  { name: "Categories", path: "/admin/categories", icon: <Layers size={20} /> },
  { name: "Support Tickets", path: "/admin/support", icon: <Mail size={20} />, badgeKey: "support" },
];

export default function AdminSidebar() {
  const location = useLocation();
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const fetchPendingCount = async () => {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      if (!token) return;
      try {
        const res = await axios.get(`${apiUrl}/api/admin/support`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const pending = res.data.filter(t => t.status === "pending").length;
        setPendingCount(pending);
      } catch (err) {
        // silently ignore – sidebar should not break if API fails
      }
    };

    fetchPendingCount();
    const interval = setInterval(fetchPendingCount, 30000); // refresh every 30s
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  return (
    <div className="w-64 bg-white h-screen border-r border-gray-200 flex flex-col fixed left-0 top-0">
      <div className="p-6 border-b border-gray-200">
        <Link to="/" className="text-2xl font-bold text-green-600">WebHulu Admin</Link>
      </div>

      <nav className="flex-grow p-4 space-y-2 overflow-y-auto">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          const showBadge = item.badgeKey === "support" && pendingCount > 0;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 relative ${
                isActive 
                  ? "bg-green-600 text-white shadow-lg shadow-green-200" 
                  : "text-gray-600 hover:bg-gray-50 hover:text-green-600"
              }`}
            >
              {item.icon}
              <span className="font-medium">{item.name}</span>
              {showBadge && (
                <span
                  className={`ml-auto min-w-[22px] h-[22px] flex items-center justify-center rounded-full text-[11px] font-bold leading-none px-1.5 ${
                    isActive
                      ? "bg-white text-green-700"
                      : "bg-red-500 text-white animate-pulse"
                  }`}
                >
                  {pendingCount > 99 ? "99+" : pendingCount}
                </span>
              )}
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-3 w-full text-gray-600 hover:bg-red-50 hover:text-red-600 rounded-xl transition-all duration-200"
        >
          <LogOut size={20} />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
}
